import { useState } from "react";
import { Link } from 'react-router-dom';
import './Sidebar1.css';


function Sidebar1() {
    const [openMenu, setOpenMenu] = useState(null); // Track which menu is open
    const sideToggle = () => {
        if (document.body.classList.contains("toggle-sidebar")) {
            document.body.classList.add("closing-sidebar");
            setTimeout(() => {
                document.body.classList.remove("toggle-sidebar", "closing-sidebar");
            }, 300);
        }
    };
    const toggleMenu = (menuId) => {
        setOpenMenu(openMenu === menuId ? null : menuId); // Toggle or close the menu
    };
    const show = JSON.parse(localStorage.getItem("Login"));



    return (
        <aside id="sidebar1" className="sidebar1">

            <ul className="sidebar1-nav" id="sidebar1-nav">
                <li className="nav-item" onClick={sideToggle} style={{ padding: "0px" }}>
                    <Link className="nav-link">
                        <span>BRANCH :</span>
                        <span>{show?.Branch_Name}</span>
                    </Link>
                </li>
                <li className="nav-item" onClick={sideToggle}>
                    <Link to="/dashboard" className="nav-link">
                        <i className="bi bi-grid"></i>
                        <span>Dashboard</span>
                    </Link>
                </li>

                {show?.UserType === "Admin" && (
                    (show?.BranchName === 1 ||
                        show?.BankName === 1 ||
                        show?.Mode_Master === 1 ||
                        show?.DeliveryMaster === 1 ||
                        show?.CustomerName === 1 ||
                        show?.CustomerCharges === 1 ||
                        show?.CustomerOda === 1 ||
                        show?.UpdateCustomerRate === 1 ||
                        show?.CustomerRate === 1 ||
                        show?.CustomerVolumetric === 1 ||
                        show?.ConsineeName === 1 ||
                        show?.ShipperName === 1 ||
                        show?.ModeWiseGst === 1 ||
                        show?.InterNationalCity === 1 ||
                        show?.DomesticCity === 1 ||
                        show?.PincodeList === 1 ||
                        show?.CityControl === 1 ||
                        show?.MultipleZone === 1 ||
                        show?.StateMaster === 1 ||
                        show?.CountryMaster === 1 ||
                        show?.VendorName === 1 ||
                        show?.VendorRate === 1 ||
                        show?.VendorCharges === 1 ||
                        show?.VendorFeul === 1 ||
                        show?.VendorGSTMaster === 1 ||
                        show?.VehicleDetails === 1 ||
                        show?.TransportDetails === 1 ||
                        show?.DriverDetails === 1 ||
                        show?.StockDetails === 1 ||
                        show?.StockIssueBranchWise === 1 ||
                        show?.StockIssueCustomerWise === 1 ||
                        show?.StockIssueEmployeeWise === 1 ||
                        show?.StatusMaster === 1
                    ) && (
                        <li className="nav-item">
                            <span
                                className="nav-link collapsed"
                                onClick={() => toggleMenu('adminMaster')}
                            >
                                <i className="bi bi-person"></i>
                                <span>Admin Master</span>

                                <i className={`bi ${openMenu === 'adminMaster'
                                        ? 'bi-chevron-up'
                                        : 'bi-chevron-down'
                                    } ms-auto`} />
                            </span>

                            <ul
                                id="components-nav"
                                className={`nav-content collapse ${openMenu === 'adminMaster' ? 'show' : ''
                                    }`}
                            >

                                {/* Branch Master */}
                                {(
                                    show?.BranchName === 1 ||
                                    show?.BankName === 1 ||
                                    show?.Mode_Master === 1 ||
                                    show?.DeliveryMaster === 1
                                ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/branchmaster">
                                                <i className="bi bi-asterisk"></i>
                                                <span>Branch Master</span>
                                            </Link>
                                        </li>
                                    )}

                                {/* Customer List */}
                                {(
                                    show?.CustomerName === 1 ||
                                    show?.CustomerCharges === 1 ||
                                    show?.CustomerOda === 1 ||
                                    show?.UpdateCustomerRate === 1 ||
                                    show?.CustomerRate === 1 ||
                                    show?.CustomerVolumetric === 1
                                ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/customerlist">
                                                <i className="bi bi-file-person"></i>
                                                <span>Customer List</span>
                                            </Link>
                                        </li>
                                    )}

                                {/* Consignee List */}
                                {(
                                    show?.ConsineeName === 1 ||
                                    show?.ShipperName === 1 ||
                                    show?.ModeWiseGst === 1
                                ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/customercharges">
                                                <i className="bi bi-cash-coin"></i>
                                                <span>Consignee List</span>
                                            </Link>
                                        </li>
                                    )}

                                {/* City Master */}
                                {(
                                    show?.InterNationalCity === 1 ||
                                    show?.DomesticCity === 1 ||
                                    show?.PincodeList === 1
                                ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/citymaster">
                                                <i className="bi bi-buildings-fill"></i>
                                                <span>City Master</span>
                                            </Link>
                                        </li>
                                    )}

                                {/* Area Control */}
                                {(
                                    show?.CityControl === 1 ||
                                    show?.MultipleZone === 1 ||
                                    show?.StateMaster === 1 ||
                                    show?.CountryMaster === 1
                                ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/tab">
                                                <i className="bi bi-stack"></i>
                                                <span>Area Control</span>
                                            </Link>
                                        </li>
                                    )}

                                {/* Vendor Master */}
                                {(
                                    show?.VendorName === 1 ||
                                    show?.VendorRate === 1 ||
                                    show?.VendorCharges === 1 ||
                                    show?.VendorFeul === 1 ||
                                    show?.VendorGSTMaster === 1
                                ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/vendormaster">
                                                <i className="bi bi-badge-vr"></i>
                                                <span>Vendor Master</span>
                                            </Link>
                                        </li>
                                    )}

                                {/* Vehicle Details */}
                                {(
                                    show?.VehicleDetails === 1 ||
                                    show?.TransportDetails === 1 ||
                                    show?.DriverDetails === 1
                                ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/vehiclemaster">
                                                <i className="bi bi-truck"></i>
                                                <span>Vehicle Details</span>
                                            </Link>
                                        </li>
                                    )}

                                {/* Stock Details */}
                                {(
                                    show?.StockDetails === 1 ||
                                    show?.StockIssueBranchWise === 1 ||
                                    show?.StockIssueCustomerWise === 1 ||
                                    show?.StockIssueEmployeeWise === 1
                                ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/inventory">
                                                <i className="bi bi-cart"></i>
                                                <span>Stock Details</span>
                                            </Link>
                                        </li>
                                    )}

                                {/* Status Master */}
                                {show?.StatusMaster === 1 && (

                                    <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                        <Link to="/regionmaster">
                                            <i className="bi bi-globe-americas"></i>
                                            <span>Status Master</span>
                                        </Link>
                                    </li>
                                )}

                            </ul>
                        </li>
                    )
                )}


                {
                    (
                        show?.DocketBooking === 1 ||
                        show?.DocketPrint === 1 ||
                        show?.CoshTopayBooking === 1 ||
                        show?.Smartbooking === 1 ||
                        show?.AutoMail === 1 ||
                        show?.BulkImportData === 1 ||
                        show?.PerformaInvoice === 1 ||
                        show?.ForwardingInternational === 1 ||
                        show?.RateCalculator === 1 ||

                        show?.PendingManifest === 1 ||
                        show?.OutgoingManifest === 1 ||
                        show?.ViewManifest === 1 ||
                        show?.InternationalManifest === 1 ||
                        show?.BuilkimportManifest === 1 ||

                        show?.PendingScan === 1 ||
                        show?.InscanbyDRSNo === 1 ||
                        show?.ScanbyDocketNo === 1 ||
                        show?.InscanProcessView === 1 ||

                        show?.DrsView === 1 ||
                        show?.Drsimport === 1 ||
                        show?.DeliveryPending === 1 ||
                        show?.DeliveryBooking === 1 ||

                        show?.Statusactivity === 1 ||
                        show?.StatusactivityimportBulk === 1 ||
                        show?.StatusactivityTracking === 1 ||

                        show?.DeliveryEntry === 1 ||
                        show?.ReturnEntry === 1 ||
                        show?.BulkUploadExcel === 1 ||

                        show?.ComplaintRegister === 1 ||
                        show?.ViewComplaintStatus === 1 ||
                        show?.ComplaintQuery === 1 ||

                        show?.InternationalBooking === 1 ||

                        show?.VendorBillEntry === 1
                    )
                    &&
                    (<li className="nav-item">
                        <span className="nav-link collapsed"
                            onClick={() => toggleMenu('booking')}>
                            <i className="bi bi-menu-button-wide"></i>
                            <span>Order Management</span>
                            <i className={`bi ${openMenu === 'booking' ? 'bi-chevron-up' : 'bi-chevron-down'} ms-auto`}></i>
                        </span>

                        <ul id="components1-nav"
                            className={`nav-content collapse ${openMenu === 'booking' ? 'show' : ''}`}>
                            {
                                (
                                    show?.DocketBooking === 1 ||
                                    show?.DocketPrint === 1 ||
                                    show?.CoshTopayBooking === 1 ||
                                    show?.Smartbooking === 1 ||
                                    show?.AutoMail === 1 ||
                                    show?.BulkImportData === 1 ||
                                    show?.PerformaInvoice === 1 ||
                                    show?.ForwardingInternational === 1 ||
                                    show?.RateCalculator === 1
                                )
                                && (<li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                    <Link to="/dailybooking" className="link">
                                        <i className="bi bi-stack"></i>
                                        <span>Docket Booking</span>
                                    </Link>
                                </li>
                                )
                            }

                            {show?.Smartbooking === 1 && <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                <Link to="/smartbooking">
                                    <i className="bi bi-stack"></i>
                                    <span>Smart Booking</span>
                                </Link>
                            </li>}
                            {
                                (
                                    show?.PendingManifest === 1 ||
                                    show?.OutgoingManifest === 1 ||
                                    show?.ViewManifest === 1 ||
                                    show?.InternationalManifest === 1 ||
                                    show?.BuilkimportManifest === 1
                                ) && (
                                    <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                        <Link to="/dailymanifest">
                                            <i className="bi bi-cart3"></i>
                                            <span>Outgoing Manifest</span>
                                        </Link>
                                    </li>
                                )
                            }

                            {
                                (
                                    show?.PendingScan === 1 ||
                                    show?.InscanbyDRSNo === 1 ||
                                    show?.ScanbyDocketNo === 1 ||
                                    show?.InscanProcessView === 1
                                ) && (
                                    <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                        <Link to="/inscan">
                                            <i className="bi bi-truck"></i>
                                            <span>Inscan Process Hub</span>
                                        </Link>
                                    </li>
                                )
                            }

                            {
                                (
                                    show?.DrsView === 1 ||
                                    show?.Drsimport === 1 ||
                                    show?.DeliveryPending === 1 ||
                                    show?.DeliveryBooking === 1
                                ) && (
                                    <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                        <Link to="/runsheet">
                                            <i className="bi bi-layout-text-sidebar-reverse"></i>
                                            <span>Delivery Run Sheet</span>
                                        </Link>
                                    </li>
                                )
                            }

                            {
                                (
                                    show?.Statusactivity === 1 ||
                                    show?.StatusactivityimportBulk === 1 ||
                                    show?.StatusactivityTracking === 1
                                ) && (
                                    <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                        <Link to="/statusactivity">
                                            <i className="bi bi-ui-checks-grid"></i>
                                            <span>Status Activity Entry</span>
                                        </Link>
                                    </li>
                                )
                            }

                            {
                                (
                                    show?.DeliveryEntry === 1 ||
                                    show?.ReturnEntry === 1 ||
                                    show?.BulkUploadExcel === 1
                                ) && (
                                    <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                        <Link to="/podentry">
                                            <i className="bi bi-ui-checks"></i>
                                            <span>Delivery Updation</span>
                                        </Link>
                                    </li>
                                )
                            }

                            {
                                (
                                    show?.ComplaintRegister === 1 ||
                                    show?.ViewComplaintStatus === 1 ||
                                    show?.ComplaintQuery === 1
                                ) && (
                                    <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                        <Link to="/custquery">
                                            <i className="bi bi-person-raised-hand"></i>
                                            <span>Customer Queries</span>
                                        </Link>
                                    </li>
                                )
                            }

                            {
                                (
                                    show?.InternationalBooking === 1
                                ) && (
                                    <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                        <Link to="/internationalbooking">
                                            <i className="bi bi-person-raised-hand"></i>
                                            <span>Status Upload</span>
                                        </Link>
                                    </li>
                                )
                            }

                            {show?.VendorBillEntry === 1 && <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                <Link to="/vendorbill">
                                    <i className="bi bi-person-raised-hand"></i>
                                    <span>Vendor Bill Entry</span>
                                </Link>
                            </li>}


                        </ul>

                    </li>
                    )}


                {
                    (
                        show?.DocketPrint1 === 1 ||
                        show?.Docketprint2 === 1 ||
                        show?.Docketprint3 === 1 ||
                        show?.Docketprint4 === 1 ||
                        show?.LebelPrintin === 1 ||
                        show?.DocketPrint === 1 ||
                        show?.StickerPrinting === 1
                    ) && (
                        <li className="nav-item">
                            <span
                                className="nav-link collapsed"
                                onClick={() => toggleMenu('docket')}
                            >
                                <i className="bi bi-printer-fill"></i>
                                <span>Docket Receipt</span>

                                <i
                                    className={`bi ${openMenu === 'docket'
                                        ? 'bi-chevron-up'
                                        : 'bi-chevron-down'
                                        } ms-auto`}
                                ></i>
                            </span>

                            <ul
                                id="components2-nav"
                                className={`nav-content collapse ${openMenu === 'docket' ? 'show' : ''
                                    }`}
                            >
                                <li
                                    className="compo-tab"
                                    id="compo-tab"
                                    onClick={sideToggle}
                                >
                                    <Link to="/docketprint" className="link">
                                        <i className="bi bi-printer"></i>
                                        <span>Docket Print</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    )
                }


                {
                    (
                        show?.PendingInvoice === 1 ||
                        show?.GenerateInvoice === 1 ||
                        show?.ViewInvoice === 1 ||
                        show?.InvoiceSummary === 1 ||
                        show?.Docket_Print === 1 ||
                        show?.PerformanceInvoice === 1 ||
                        show?.ViewPerformanceInvoice === 1
                    ) && (
                        <li className="nav-item">
                            <span
                                className="nav-link collapsed"
                                onClick={() => toggleMenu('invoice')}
                            >
                                <i className="bi bi-receipt-cutoff"></i>
                                <span>Invoice / Billing</span>

                                <i
                                    className={`bi ${openMenu === 'invoice'
                                        ? 'bi-chevron-up'
                                        : 'bi-chevron-down'
                                        } ms-auto`}
                                ></i>
                            </span>

                            <ul
                                id="components3-nav"
                                className={`nav-content collapse ${openMenu === 'invoice' ? 'show' : ''
                                    }`}
                            >
                                <li
                                    className="compo-tab"
                                    id="compo-tab"
                                    onClick={sideToggle}
                                >
                                    <Link to="/invoice" className="link">
                                        <i className="bi bi-receipt-cutoff"></i>
                                        <span>Invoice Generate</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    )
                }

                {
                    (
                        show?.PaymentReceivedEntry === 1 ||
                        show?.PayOutStanding === 1 ||
                        show?.CreditBooking === 1 ||
                        show?.CreditNoteView === 1
                    ) && (
                        <li className="nav-item">
                            <span
                                className="nav-link collapsed"
                                onClick={() => toggleMenu('laiser')}
                            >
                                <i className="bi bi-cash-coin"></i>
                                <span>Laiser / Payment</span>

                                <i
                                    className={`bi ${openMenu === 'laiser'
                                        ? 'bi-chevron-up'
                                        : 'bi-chevron-down'
                                        } ms-auto`}
                                ></i>
                            </span>

                            <ul
                                id="components4-nav"
                                className={`nav-content collapse ${openMenu === 'laiser' ? 'show' : ''
                                    }`}
                            >
                                <li
                                    className="compo-tab"
                                    id="compo-tab"
                                    onClick={sideToggle}
                                >
                                    <Link to="/laiser" className="link">
                                        <i className="bi bi-cash-stack"></i>
                                        <span>Laiser / Payment</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    )
                }

                {
                    (
                        show?.MISReport === 1 ||
                        show?.VendorMISReport === 1 ||
                        show?.BookingModeReport === 1 ||
                        show?.TotalChargesReport === 1 ||
                        show?.ModeWiseReport === 1 ||
                        show?.BookingDetail === 1 ||
                        show?.InvoiceLedgerReport === 1 ||
                        show?.ChecklistReport === 1 ||
                        show?.UnbuildReport === 1 ||
                        show?.BillViewReport === 1
                    ) && (
                        <li className="nav-item">
                            <span
                                className="nav-link collapsed"
                                onClick={() => toggleMenu('reports')}
                            >
                                <i className="bi bi-clipboard-data"></i>
                                <span>Reports</span>

                                <i
                                    className={`bi ${openMenu === 'reports'
                                        ? 'bi-chevron-up'
                                        : 'bi-chevron-down'
                                        } ms-auto`}
                                ></i>
                            </span>

                            <ul
                                id="components5-nav"
                                className={`nav-content collapse ${openMenu === 'reports' ? 'show' : ''
                                    }`}
                            >

                                {/* Booking MIS Report */}
                                {
                                    (
                                        show?.MISReport === 1 ||
                                        show?.VendorMISReport === 1 ||
                                        show?.BookingModeReport === 1
                                    ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            
                                            <Link to="/statusreport" className="link">
                                                <i className="bi bi-filter-square"></i>
                                                <span>Booking MIS Report</span>
                                            </Link>
                                        </li>
                                    )
                                }

                                {/* Booking Detail Report */}
                                {
                                    (
                                        show?.TotalChargesReport === 1 ||
                                        show?.ModeWiseReport === 1 ||
                                        show?.BookingDetail === 1
                                    ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/statement">
                                                <i className="bi bi-layout-text-sidebar-reverse"></i>
                                                <span>Booking Detail Report</span>
                                            </Link>
                                        </li>
                                    )
                                }

                                {/* Sales Register Report */}
                                {
                                    (
                                        show?.InvoiceLedgerReport === 1 ||
                                        show?.ChecklistReport === 1 ||
                                        show?.UnbuildReport === 1 ||
                                        show?.BillViewReport === 1
                                    ) && (
                                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                                            <Link to="/salesregister">
                                                <i className="bi bi-filter-square"></i>
                                                <span>Invoice Ledger Report</span>
                                            </Link>
                                        </li>
                                    )
                                }

                            </ul>
                        </li>
                    )
                }


                {show?.UserType == "Admin" && <li className="nav-item">
                    <span className="nav-link collapsed"
                        onClick={() => toggleMenu('userControl')}>
                        <i className="bi bi-universal-access"></i>
                        <span>User Control</span>
                        <i className={`bi ${openMenu === 'userControl' ? 'bi-chevron-up' : 'bi-chevron-down'} ms-auto`}></i>
                    </span>
                    <ul id="forms-nav"
                        className={`nav-content collapse ${openMenu === 'userControl' ? 'show' : ''}`}>
                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                            <Link to="/useradmin">
                                <i className="bi bi-incognito"></i>
                                <span>User Login</span>
                            </Link>
                        </li>

                        <li className="compo-tab" id="compo-tab" onClick={sideToggle}>
                            <Link to="/branchadmin">
                                <i className="bi bi-x-diamond-fill"></i>
                                <span>Branch Login</span>
                            </Link>
                        </li>
                    </ul>
                </li>}

            </ul>
        </aside >

    );
};


export default Sidebar1;